




















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { WayfinderCSS } from "@/services/wayfinder/types";

@Component
export default class WayfinderStyle extends Vue {
    @Prop() private itemStyle!: Style;
    // lifecycle hooks
    get model(): WayfinderCSS {
        return this.itemStyle.css
            ? (this.itemStyle.css as WayfinderCSS)
            : ({} as WayfinderCSS);
    }
}
